export enum BusinessLogUrl {
  SEARCH = '/business-log{?page,size,sort*,classifier,createdAt,createdBy,action,logData,logData2,description,mapping,type,logDataValueDate,logDataSubject,traceId,hasSharedTraceId}',
  ALGORITHM_FILE = '/business-log/download-algorithm-file{?s3Path,fileName}',
}
